export default __webpack_public_path__ + "static/media/ken-office.f2d6f21a.jpg";